<div class="tw-reset tw-mx-4 tw-grid tw-h-dvh tw-place-items-center md:tw-mx-0">
  <div
    class="tw-absolute tw-top-14 tw-w-[488px] tw-rounded-2xl tw-bg-white tw-p-6 tw-pb-4 tw-shadow-xl"
    role="dialog"
  >
    <h4 class="tw-mb-4 tw-font-extrabold tw-text-neutral-800">
      {{ i18n.RequestRating_Header }}
    </h4>

    <!-- show search when manager not selected -->
    @if (!requestedManager()) {
      <dgx-user-search-v3
        [searchFn]="loadPotentialRaters"
        placeHolderLabel="{{ i18n.Core_SearchForManagerLabel }}"
        ariaLabel="{{ i18n.Core_SearchForManagerLabel }}"
        (onSelect)="onSelectItem($event)"
      ></dgx-user-search-v3>
    }

    <!-- show selected manager when manager is selected -->
    @if (requestedManager()) {
      <h5 class="tw-font-semibold tw-text-neutral-800">
        {{ i18n.TargetResourcesForm_Selected }}
      </h5>
      <dgx-user-search-item-v3
        [item]="requestedManager()"
        [isRemovable]="true"
        (onRemove)="onRemoveItem()"
      ></dgx-user-search-item-v3>
    }
    <div class="tw-flex tw-w-full tw-justify-end tw-gap-4 tw-pt-6">
      <button
        type="button"
        class="tw-btn-medium tw-btn-secondary-filled"
        [attr.aria-label]="i18n.Core_Cancel"
        (click)="cancel()"
      >
        {{ i18n.Core_Cancel }}
      </button>
      <button
        type="button"
        class="tw-btn-primary tw-btn-medium"
        [disabled]="!requestedManager() || isRequestProcessing()"
        data-dgat="tag-rating-request-modal-57e"
        [attr.aria-label]="i18n.RequestRating_SendRequest"
        (click)="submit()"
      >
        {{ i18n.RequestRating_SendRequest }}
      </button>
    </div>
  </div>
</div>
